// extracted by mini-css-extract-plugin
export default {"fieldGroup":"preferences_fieldGroup__ocKbk","fieldLabel":"preferences_fieldLabel__RRs2c","iconInfo":"preferences_iconInfo__8H5Lc","formBody":"preferences_formBody__GiFCC"};